var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.$style.Popup,style:({
    display: _vm.display ? 'block' : 'none',
    visibility: _vm.visible ? 'visible' : 'hidden'
  })},[_c('div',{class:_vm.$style.Header},[_vm._v(_vm._s(_vm.$t('ui.lang.error')))]),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }